/* Reliable add-to-cart handling for custom Getsetwear product cards and product page. */
(function () {
  if (window.__gswAddToCartReady) return;
  window.__gswAddToCartReady = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var addUrl = root + 'cart/add.js';
  var cartUrl = root + 'cart';

  function labelFor(button) {
    return button.querySelector('[data-gsw-atc-label]') || button;
  }

  function messageFrom(payload, fallback) {
    if (!payload) return fallback;
    return payload.description || payload.message || fallback;
  }

  function addVariant(button, variantId) {
    var label = labelFor(button);
    var original = label.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding...';

    return fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok) throw new Error(messageFrom(payload, 'Could not add this item to cart.'));
          return payload;
        });
      })
      .then(function () {
        label.textContent = 'Added';
        window.setTimeout(function () { window.location.assign(cartUrl); }, 250);
      })
      .catch(function (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = original;
        window.alert(error && error.message ? error.message : 'Could not add this item to cart. Please try again.');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gsw-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      var productUrl = button.getAttribute('data-product-url');
      if (productUrl) window.location.assign(productUrl);
      return;
    }
    addVariant(button, variantId);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'gswpForm') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var button = form.querySelector('button.atc[type="submit"]');
    var input = form.querySelector('#gswpVariantId');
    if (!button || !input || !input.value || button.disabled) return;
    addVariant(button, input.value);
  }, true);
})();